import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Stethoscope = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="stethoscope icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66334 7.80081L7.73666 9.94743L4.83062 11.4005C4.9937 14.5863 5.62022 18.9354 7.24493 22.5581C8.99399 26.458 11.7635 29.2741 16.2 29.2741C20.6244 29.2741 23.2965 26.4734 25.0002 22.5692C26.5793 18.9504 27.2045 14.6144 27.5274 11.3795L24.6633 9.94743L25.7367 7.80081L30.0692 9.96709L29.9951 10.7828C29.6944 14.0898 29.0841 19.211 27.1998 23.5291C25.3035 27.8748 21.9756 31.6741 16.2 31.6741C10.4365 31.6741 7.00601 27.8902 5.05507 23.5402C3.11364 19.2113 2.50277 14.0836 2.40055 10.7105L2.37732 9.94382L6.66334 7.80081Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.651 39.9992C15.0678 36.7462 14.7926 32.9128 15.0041 30.3745L17.3958 30.5738C17.2074 32.8354 17.4722 36.2021 18.809 38.949C19.4701 40.3075 20.3754 41.4786 21.5834 42.311C22.7818 43.1367 24.3425 43.6741 26.4 43.6741C30.5207 43.6741 32.885 41.8051 34.2567 39.9585C34.9553 39.0181 35.4022 38.072 35.6736 37.3594C35.8087 37.0047 35.8987 36.7124 35.9537 36.5141C35.9812 36.4151 35.9999 36.3399 36.011 36.2926C36.0141 36.2796 36.0166 36.2687 36.0186 36.26C36.0202 36.2529 36.0214 36.2473 36.0223 36.2432L36.0235 36.2377C36.0235 36.2377 36.0233 36.2388 37.2 36.4741C38.3767 36.7095 38.3764 36.7108 38.3764 36.7108L38.3754 36.7158L38.3735 36.7253L38.3675 36.7533C38.3626 36.7759 38.3557 36.8064 38.3468 36.8443C38.3289 36.92 38.3026 37.0253 38.2663 37.156C38.1938 37.417 38.0813 37.781 37.9164 38.2138C37.5878 39.0763 37.0447 40.2301 36.1833 41.3897C34.435 43.7432 31.3993 46.0741 26.4 46.0741C23.8975 46.0741 21.8532 45.4115 20.2216 44.2873C18.5996 43.1696 17.4499 41.6408 16.651 39.9992Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2 6.0001C9.20589 6.0001 8.4 6.80598 8.4 7.8001C8.4 8.79421 9.20589 9.6001 10.2 9.6001C11.1941 9.6001 12 8.79421 12 7.8001C12 6.80598 11.1941 6.0001 10.2 6.0001ZM6 7.8001C6 5.4805 7.8804 3.6001 10.2 3.6001C12.5196 3.6001 14.4 5.4805 14.4 7.8001C14.4 10.1197 12.5196 12.0001 10.2 12.0001C7.8804 12.0001 6 10.1197 6 7.8001Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.2 6.0001C21.2059 6.0001 20.4 6.80598 20.4 7.8001C20.4 8.79421 21.2059 9.6001 22.2 9.6001C23.1941 9.6001 24 8.79421 24 7.8001C24 6.80598 23.1941 6.0001 22.2 6.0001ZM18 7.8001C18 5.4805 19.8804 3.6001 22.2 3.6001C24.5196 3.6001 26.4 5.4805 26.4 7.8001C26.4 10.1197 24.5196 12.0001 22.2 12.0001C19.8804 12.0001 18 10.1197 18 7.8001Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.8 24.4741C34.8177 24.4741 32.4 26.8918 32.4 29.8741C32.4 32.8565 34.8177 35.2741 37.8 35.2741C40.7823 35.2741 43.2 32.8565 43.2 29.8741C43.2 26.8918 40.7823 24.4741 37.8 24.4741ZM30 29.8741C30 25.5663 33.4922 22.0741 37.8 22.0741C42.1078 22.0741 45.6 25.5663 45.6 29.8741C45.6 34.1819 42.1078 37.6741 37.8 37.6741C33.4922 37.6741 30 34.1819 30 29.8741Z"
    />
    <path
      className={pathClass}
      d="M40.8 29.8741C40.8 31.531 39.4569 32.8741 37.8 32.8741C36.1431 32.8741 34.8 31.531 34.8 29.8741C34.8 28.2173 36.1431 26.8741 37.8 26.8741C39.4569 26.8741 40.8 28.2173 40.8 29.8741Z"
    />
  </svg>
)
